// extracted by mini-css-extract-plugin
export default {"container":"PEsiobmmjG2Az7BSnfjq","form":"AS8uwiGq6rkh9cfQbWgl","formSpace":"Zh7VtkFRH0xo7HwCTHQ9"};